export default __webpack_public_path__ + "static/triangle_w.bdda3ca32fb0402dbaaba5b2c610d380.png";